import { useQuery } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import {
  WorkspaceMember,
  getWorkspaceMembers,
} from '../../../api/workspaces/getWorkspaceMembers';

export function useWorkspaceMembers<T = WorkspaceMember[]>({
  workspaceId,
  select,
  enabled = true,
}: {
  workspaceId: string;
  select?: (workspaceMembers: WorkspaceMember[]) => T;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: workspaceKeys.members(workspaceId),
    queryFn: () =>
      getWorkspaceMembers(workspaceId).then((data) => data.members),
    select: select,
    enabled: enabled,
  });
}
